import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const RECENT = 30 * 60 * 1000;
const ago = (iso) => { const s = Math.max(0, Math.round((Date.now() - new Date(iso)) / 1000)); return s < 60 ? `${s}s ago` : `${Math.round(s / 60)} min ago`; };
const fresh = (iso) => iso && Date.now() - new Date(iso) < RECENT;

const Row = ({ id, icon, title, text, at }) => (
  <li data-testid={id} className="flex items-start gap-2 py-1.5 text-sm">
    <span className="mt-0.5 shrink-0">{icon}</span>
    <span className="min-w-0"><b className="text-[#2B2A26]">{title}</b> <span className="text-stone-600">— {text}</span>{at && <span className="ml-2 text-[11px] text-stone-400">{ago(at)}</span>}</span>
  </li>
);
const spin = <Loader2 size={14} className="animate-spin text-[#9A7B2C]" />;
const ok = <CheckCircle2 size={14} className="text-emerald-700" />;
const bad = <XCircle size={14} className="text-amber-700" />;

const fillText = (r) => r.error ? r.error : r.fit_block ? (r.fit_ok ? "spill fixed — the page fits on one page now" : "the page still runs over")
  : `finished — ${r.overflow || 0} page(s) running over · ${r.light_pages || 0} light page(s) left`;

export const LiveActivity = ({ kit }) => {
  const rows = [];
  if (kit.filling) rows.push(<Row key="fill" id="live-fill" icon={spin} title="Page fill / spill fix" text={kit.progress?.current || "Working…"} at={kit.heartbeat_at} />);
  else if (kit.fill_result && fresh(kit.fill_result.at)) rows.push(<Row key="fill" id="live-fill" icon={kit.fill_result.error ? bad : ok} title="Page fill / spill fix" text={fillText(kit.fill_result)} at={kit.fill_result.at} />);
  const all = kit.style_fix_all;
  if (all?.status === "running") {
    const n = (all.done?.length || 0) + (all.failed?.length || 0) + (all.kept?.length || 0) + 1;
    rows.push(<Row key="all" id="live-rewrite-all" icon={spin} title="Rewrite-all" text={`page ${Math.min(n, all.total)} of ${all.total}${all.current ? ` · p.${all.current.n} ${all.current.label}` : ""}`} at={all.beat} />);
  }
  Object.entries(kit.fix_steps || {}).filter(([, s]) => fresh(s.at)).sort((a, b) => (b[1].at > a[1].at ? 1 : -1)).slice(0, 8).forEach(([b, s]) =>
    rows.push(<Row key={b} id={`live-step-${b}`} icon={!s.done ? spin : s.ok ? ok : bad} title={`Rewrite p.${s.n ?? "?"} ${s.label || b}`} text={s.step} at={s.at} />));
  if (kit.page_checking && !kit.filling) rows.push(<Row key="pc" id="live-page-check" icon={spin} title="Page check" text="measuring every page of the PDF to refresh the scores" />);
  if (!rows.length) return null;
  return (
    <section data-testid="live-activity" className="sticky top-0 z-20 mb-6 rounded-lg border border-[#C9A847]/40 bg-white/95 px-4 py-2 shadow-sm backdrop-blur">
      <div className="text-[10px] font-bold uppercase tracking-widest text-[#9A7B2C]">Live activity</div>
      <ul className="divide-y divide-stone-100">{rows}</ul>
    </section>
  );
};
